module.exports = __webpack_public_path__ + "img/inmatic_logo.70cc409f.svg";